"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpChart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var merge_1 = __importDefault(require("lodash/merge"));
var chart_js_1 = __importDefault(require("chart.js"));
var baseChartOptions_1 = require("./baseChartOptions");
var chartTypes_enum_1 = require("./chartTypes.enum");
var chartInstance;
var DpChart = function (_a) {
    var options = _a.options, _b = _a.plugins, plugins = _b === void 0 ? {} : _b, _c = _a.datasets, datasets = _c === void 0 ? [] : _c, _d = _a.labels, labels = _d === void 0 ? [] : _d, _e = _a.id, id = _e === void 0 ? '' : _e, _f = _a.type, type = _f === void 0 ? chartTypes_enum_1.LibraryChartTypes.Bar : _f, _g = _a.ariaLabel, ariaLabel = _g === void 0 ? '' : _g;
    var chartRef = (0, react_1.useRef)(null);
    var firstDataset = datasets[0] && datasets[0].data;
    var dsLength = firstDataset ? firstDataset.length : 0;
    var height = options.height, width = options.width;
    var canvasProps = (0, react_1.useMemo)(function () {
        var props = {
            id: id,
            'aria-label': ariaLabel,
            role: 'img',
        };
        if (height) {
            props.height = height;
            props.width = width;
        }
        return props;
    }, [ariaLabel, id, height, width]);
    var chartOptions = (0, react_1.useMemo)(function () { return (0, merge_1.default)((0, baseChartOptions_1.getBaseBarChartOptions)(), options || {}); }, [options]);
    (0, react_1.useEffect)(function () {
        if (!chartRef.current) {
            return;
        }
        if (!chartInstance)
            chartInstance = {};
        if (chartInstance[id])
            chartInstance[id].destroy();
        chartInstance[id] = new chart_js_1.default(chartRef.current.getContext('2d'), {
            type: type,
            options: chartOptions,
            plugins: plugins,
            data: {
                labels: labels.length === dsLength ? labels : new Array(dsLength).fill(''),
                datasets: datasets,
            },
        });
    }, [id, plugins, chartOptions, datasets, labels, dsLength, type]);
    return (0, jsx_runtime_1.jsx)("canvas", __assign({}, canvasProps, { ref: chartRef }));
};
exports.DpChart = DpChart;
exports.default = exports.DpChart;
